import { Context, Duration } from 'effect';
import { constVoid } from 'effect/Function';
import * as FindMyWay from 'effect/unstable/http/FindMyWay';
import { HttpApi, HttpApiGroup } from 'effect/unstable/httpapi';

const DEFAULT_REQUEST_TIMEOUT = Duration.seconds(20);

export const API_ROUTER_CONFIG = {
  maxParamLength: 300,
} satisfies Partial<FindMyWay.RouterConfig>;

export const RequestTimeout = Context.Reference<Duration.Duration>(
  'listening/api-contract/RequestTimeout',
  { defaultValue: () => DEFAULT_REQUEST_TIMEOUT },
);

const isPathInput = (path: string): path is FindMyWay.PathInput =>
  path.startsWith('/');

export function requestTimeoutResolver<
  Id extends string,
  Groups extends HttpApiGroup.Constraint,
>(api: HttpApi.HttpApi<Id, Groups>) {
  const router = FindMyWay.make<Duration.Duration>(API_ROUTER_CONFIG);
  HttpApi.reflect(api, {
    onGroup: constVoid,
    onEndpoint: ({ endpoint, mergedAnnotations }) => {
      if (isPathInput(endpoint.path)) {
        router.on(
          endpoint.method,
          endpoint.path,
          Context.get(mergedAnnotations, RequestTimeout),
        );
      }
    },
  });
  return (method: string, pathname: string) =>
    router.find(method.toUpperCase(), pathname)?.handler ??
    DEFAULT_REQUEST_TIMEOUT;
}
